import { Message } from "@/types/types";
import { findPromoCode } from "@/utils/product/getPromoCode";

const TRADE_IN_ENHANCED = "Trade In - Enhanced";

function getTradeInPromoMessages(messages: Message[]) {
  return messages
    .filter((message) => message.type === "promotional")
    .filter((message) => message.promotionType === TRADE_IN_ENHANCED);
}

function getTradeInPromoMessageTitle(messages: Message[]) {
  const filterdMessages: string[] = getTradeInPromoMessages(messages).map(
    (message) => message.title,
  );

  return filterdMessages.length > 0 ? filterdMessages[0] : "";
}

function getPromotionValueFromTitle(title: string) {
  const promotionValueRegex = /(£[\w]*)/g;
  const promotionValueMatches = title.match(promotionValueRegex);

  // only consider single value matches
  if (promotionValueMatches?.length === 1) {
    return promotionValueMatches[0];
  }
  return "";
}

export function getPromotionValue(messages: Message[]) {
  const promotionTitle = getTradeInPromoMessageTitle(messages);
  return getPromotionValueFromTitle(promotionTitle || "");
}

export function hasTradeInPromoCode(messages: Message[]) {
  const tradeInPromos = getTradeInPromoMessages(messages);

  if (tradeInPromos.length === 0) return false;

  const tradeInPromo = tradeInPromos[0];

  if (!tradeInPromo || !tradeInPromo.title || !tradeInPromo.description)
    return false;

  let promoCode = findPromoCode(tradeInPromo.title);
  if (!promoCode) {
    promoCode = findPromoCode(tradeInPromo.description);
  }

  return !!promoCode;
}
